"use strict";
import React from "react";
import PropTypes from "prop-types";

const CONTEXT = {
    RMS: '0',
    PORSCHE: '1',
    HONDA: '2',
    VW: '3',
    AUDI: '4'
};

const PORSCHE_SITE = {
    ADMIN: 'porscheadmin',
    MARKETPLACE: 'porschemarket'
};
const HONDA_SITE = {
    ADMIN: 'hondaadmin',
    MARKETPLACE: 'hondavips'
};
const VW_SITE = {
    ADMIN: 'vciadmin',
    MARKETPLACE: 'vwdealer'
};
const AUDI_SITE = {
    ADMIN: 'vciadmin',
    MARKETPLACE: 'audidealer'
};
const ENVIRONMENT = {
    DEV: 'dev',
    QA: 'qa',
    SUPPORT: 'supp',
    UAT: 'uat',
    HUAT: 'huat'
};
const DOMAIN = 'flex.cafe';
const DEFAULT_HOST = 'localhost';

module.exports = (flex = window.flex) => {

    class EnvironmentSelector extends React.PureComponent {
        constructor(props, context) {
            super(props, context);
            let hostHeader = flex.getCookie('flex-host');
            console.log('hostHeader = ' + hostHeader);
            let isDefaultHost = !hostHeader || hostHeader === DEFAULT_HOST;

            this.state = {
                isDefaultHost,
                context: CONTEXT.RMS,
                environment: null,
                isAdmin: true
            };

            switch ((flex.resolveObjectPath(this.props, 'environment') || '').toLowerCase()) {
                case ENVIRONMENT.DEV:
                    this.state.environment = ENVIRONMENT.DEV;
                    break;
                case ENVIRONMENT.QA:
                    this.state.environment = ENVIRONMENT.QA;
                    break;
                case ENVIRONMENT.UAT:
                    this.state.environment = ENVIRONMENT.UAT;
                    break;
                case ENVIRONMENT.HUAT:
                    this.state.environment = ENVIRONMENT.HUAT;
                    break;
                case ENVIRONMENT.SUPPORT:
                    this.state.environment = ENVIRONMENT.SUPPORT;
                    break;
                default:
                    break;
            }

            if (!isDefaultHost) {
                let [site, environment, ...rest] = hostHeader.split('.');

                this.state.context = EnvironmentSelector.getContextBySite(site);
                this.state.isAdmin = EnvironmentSelector.getIsAdminBySite(site);
                this.state.environment = environment;
            }
        }

        static getContextBySite(site) {
            if (site.includes('porsche')) {
                return CONTEXT.PORSCHE;
            } else if (site.includes('honda')) {
                return CONTEXT.HONDA;
            } else if (site.includes('audi')) {
                return CONTEXT.AUDI;
            } else if (site.includes('vw')) {
                return CONTEXT.VW;
            } else {
                return CONTEXT.RMS;
            }
        }

        static getIsAdminBySite(site) {
            if (!site) {
                return true;
            }
            return site.includes('admin');
        }

        _selectContext = event => {
            let context = event.currentTarget.value;
            this.setState({ context });
        };

        _selectEnvironment = event => {
            let environment = event.currentTarget.value;
            this.setState({ environment });
        };

        _selectIsAdmin = event => {
            let isAdmin = event.currentTarget.checked;
            this.setState({ isAdmin });
        };

        _applyHostHeader = () => {
            const key = 'flex-host';

            const {
                context,
                environment,
                isAdmin
            } = this.state;

            let cookieValue,
                siteType = isAdmin ? 'ADMIN' : 'MARKETPLACE',
                site;

            switch (context) {
                case CONTEXT.PORSCHE:
                    site = PORSCHE_SITE[siteType];
                    break;
                case CONTEXT.HONDA:
                    site = HONDA_SITE[siteType];
                    break;
                case CONTEXT.AUDI:
                    site = AUDI_SITE[siteType];
                    break
                case CONTEXT.VW:
                    site = VW_SITE[siteType];
                    break;
            }

            if (!site) {
                cookieValue = DEFAULT_HOST;
            } else {
                cookieValue = `${site}.${environment}.${DOMAIN}`;
            }

            if (cookieValue.length) {
                flex.setCookie({ key, value: cookieValue });
            } else {
                flex.removeCookie({ key })
            }
            flex.redirect();
        };

        render() {
            const contextSelector =
                <select name="client"
                    value={this.state.context}
                    onChange={this._selectContext}>
                    <option value="0">RMS</option>
                    <option value="1">Porsche</option>
                    <option value="2">Honda</option>
                    <option value="3">VW</option>
                    <option value="4">Audi</option>
                </select>;

            let environments = Object.keys(ENVIRONMENT);
            const environmentSelector = false && this.state.context !== CONTEXT.RMS &&
                <select name="environment"
                    value={this.state.environment}
                    onChange={this._selectEnvironment}>
                    {environments.map(key => <option
                        key={key}
                        value={ENVIRONMENT[key]}>
                        {ENVIRONMENT[key]}
                    </option>)}
                </select>;

            const isAdminSelector = this.state.context !== CONTEXT.RMS && <div className="checkbox-group">
                <input type="checkbox"
                    name="isAdmin"
                    id="isAdmin"
                    checked={this.state.isAdmin}
                    onChange={this._selectIsAdmin}
                />
                <label htmlFor="isAdmin">
                    <span>Admin</span>
                </label>
            </div>;


            return <div className="form-group">
                <label>Environment: {this.props.environment}</label>
                <label>Context</label>
                <div className="clearfix">
                    <div className="pull-left">
                        {contextSelector}
                    </div>
                    <div className="pull-left">
                        {environmentSelector}
                    </div>
                    <div className="input-group pull-right" style={{ marginTop: '3px' }}>
                        {isAdminSelector}
                    </div>
                </div>
                <div className="form-group">
                    <div className="input-group-btn">
                        <button className="btn btn-secondary" onClick={this._applyHostHeader}>
                            Go!
                        </button>
                    </div>
                </div>
            </div>;
        }
    }

    EnvironmentSelector.propTypes = {
        environment: PropTypes.string.isRequired
    };

    EnvironmentSelector.defaultProps = {
        //myDefaultProp: 'abc'
    };

    return EnvironmentSelector;
};